/* カート画面ラッピングUI */
function cartWrapping() {
  const wrappingRequest = document.querySelector('#wrappingRequest'),
        wrappingAddress = document.querySelector('#wrappingAddress'),
        wrappingProducts = document.querySelector('#wrappingProducts');

  coolDeliverCheck();
  wrappingStatusCheck(wrappingRequest, wrappingAddress, wrappingProducts);
  wrappingAddressCheck(wrappingAddress, wrappingProducts);
  wrappingDefaultCheck(wrappingAddress, wrappingProducts);
}

// 「ギフトラッピングをご希望ですか？」radio選択によるUI切り替え
function wrappingStatusCheck(target, address, products) {
  const radioArray = target.querySelectorAll('input[type="radio"]');
  radioArray.forEach(function(radio) {
    radio.addEventListener('change',function(){
      if (this.value == "wrapping_show") {
        address.classList.remove("hidden");
        products.classList.remove("hidden");
      } else {
        address.classList.add("hidden");
        products.classList.add("hidden");
      }
    });
  })
}

// 届け先による商品条件分岐
function wrappingAddressCheck(target, products) {
  const radioArray = target.querySelectorAll('input[type="radio"]'),
        homeOnly = products.querySelectorAll("[data-deliver-address='home']"),
        elseOnly = products.querySelectorAll("[data-deliver-address='else']");
  
  // ラジオボタン選択時に実行
  radioArray.forEach(function(radio) {
    radio.addEventListener('change',function(){
      products.querySelector(".announce-text").classList.add("hidden");
      if (this.value == "address-home") {
        // 自宅宛てのラッピング商品
        homeOnly?.forEach(function(el) {
          if(!el.classList.contains("not-available")) {
            el.classList.remove("hidden");
          }
        });
        elseOnly?.forEach(function(el) {
          el.classList.add("hidden");
        });
      } else {
        // その他の届け先
        homeOnly?.forEach(function(el) {
          if(!el.classList.contains("not-available")) {
            el.classList.add("hidden");
          }
        });
        elseOnly?.forEach(function(el) {
          el.classList.remove("hidden");
        });

        // その他届け先＋冷凍便の場合、ラッピング商品は選択できないため代替文言を表示
        if(products.classList.contains("for-cool")) {
          products.querySelector(".announce-text").classList.remove("hidden");
        }
      }
    });
  })
}

// カート内冷凍便有無判定・商品の出し分け
// cart.js内のカート数量変更時にも再度呼び出される
function coolDeliverCheck() {
  const cartTable = document.querySelector('#cartItemTable'),
        tableRow = cartTable?.querySelectorAll('tr'),
        wrappingProducts = document.querySelector('#wrappingProducts'),
        coolOnly = wrappingProducts?.querySelectorAll("[data-deliver-type='coolOnly']"),
        normalOnly = wrappingProducts?.querySelectorAll("[data-deliver-type='normalOnly']");
  let coolDeliverTarget = false;

  if(wrappingProducts) {

    // 非表示要素のイニシャライズ
    wrappingProducts.querySelector(".announce-text").classList.add("hidden");

    // 冷凍便判定
    tableRow?.forEach(function(target) {
      if (target.getAttribute("data-deliver") == "cool") {
        coolDeliverTarget = true;
        return;
      }
      // ギフトボックス商品も冷凍便と同一のラッピングパターンとなる
      if (target.getAttribute("data-bundle") == "true") {
        coolDeliverTarget = true;
        return;
      }
    })
    // 冷凍便判定による商品出し分け
    if (coolDeliverTarget) {
      wrappingProducts.classList.add("for-cool");

      coolOnly?.forEach(function(target) {
        target.classList.remove("not-available");
      })
      normalOnly?.forEach(function(target) {
        target.classList.add("not-available");
      })

    } else {
      wrappingProducts.classList.remove("for-cool");

      normalOnly?.forEach(function(target) {
        target.classList.remove("not-available");
      })
      coolOnly?.forEach(function(target) {
        target.classList.add("not-available");
      })
    }
  }
}

// カート内商品によるradio選択初期状態の判定
// cart.js内のカート数量変更時にも再度呼び出される
function wrappingDefaultCheck() {
  if (document.querySelector('#cartWrappingConteiner')) {
    const address = document.querySelector('#wrappingAddress'),
          products = document.querySelector('#wrappingProducts'),
          cartTable = document.querySelector('#cartItemTable'),
          tableRow = cartTable?.querySelectorAll('tr'),
          elseOnlyProduct = products?.querySelector("[data-deliver-address='else']").getAttribute("data-product-id"),
          homeOnly = products?.querySelectorAll("[data-deliver-address='home']"),
          elseOnly = products?.querySelectorAll("[data-deliver-address='else']");
    let wrappingExistence = false,
        elseProductExistence = false;

    // ラッピング商品判定
    tableRow?.forEach(function(target) {
      if (target.getAttribute("data-wrapping") == "true") {
        wrappingExistence = true;
      }
      if (target.getAttribute("data-product-id") == elseOnlyProduct) {
        elseProductExistence = true;
      }
    })

    // ラッピングUIの表示判定
    if (wrappingExistence) {
      document.querySelector('#wrapping_show').checked = true;
      address.classList.remove("hidden");
      products.classList.remove("hidden");
    } else {
      document.querySelector('#wrapping_hidden').checked = true;
      address.classList.add("hidden");
      products.classList.add("hidden");
    }

    // 届け先UIの初期表示判定
    if (elseProductExistence) {
      document.querySelector('#address-else').checked = true;
      homeOnly?.forEach(function(el) {
        if(!el.classList.contains("not-available")) {
          el.classList.add("hidden");
        }
      });
      elseOnly?.forEach(function(el) {
        el.classList.remove("hidden");
      });
    }     
  }
}

window.addEventListener('load',function(){
  const wrappingUI = document.querySelector('#cartWrappingConteiner')
  if(wrappingUI) {
    cartWrapping();
  }
});